/// <reference path="../../TypeLite.Net4.d.ts" />
import { action } from 'typesafe-actions'
import { CountriesPageActionTypes } from './types'

export const showCountriesPage = () => action(CountriesPageActionTypes.SHOW_CountriesPage)
export const hideCountriesPage = () => action(CountriesPageActionTypes.HIDE_CountriesPage)

